import { useState, Fragment, useContext } from 'react';

// Import Material 
import { Button } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AutocompleteTerms } from '../../basicComponents/AutocompleteTerms';

//Import Components

export const SaveViewDialog = ({termItem,setTerm4veiw ,saveCurrentViewFunction, handleClose, render,classes}) => {

    const [open, setOpen] = useState(false);

    const handleUpdate = () => {        
        setOpen(true);
    };

    const handleSave= () => {
        saveCurrentViewFunction()
        setOpen(false);
    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            {render(handleUpdate)}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="xs" fullWidth="true">
                <DialogTitle id="form-dialog-title">Save current view</DialogTitle>
                <DialogContent>Do you want save the current view to "{termItem.name}" ?</DialogContent>

                {/* <AutocompleteTerms setTerm={setTerm4veiw} classes={classes} /> */}

                <DialogActions>
                    <Button onClick={handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}